<template>
    <modal :show="show" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title" v-if="sipdevices">{{ currentSipdevice.extensionName || sipdevice }}'s Emergency
                Calling</h5>
        </template>

        <template>
            <form>
                <div class="form-row">
                    <div class="col">
                        <base-input label="Postal code"
                                    type="text"
                                    placeholder="Enter postal code"
                                    v-model="postal_code"
                                    name="postal_code"
                                    required
                                    data-vv-as="Postal Code"
                                    :error="getError('postal_code')"
                                    v-validate="'digits:4'"
                        >
                            <small slot="helperText" id="nameHelp" class="form-text text-muted">This is the Belgian
                                postal code the device is located at.
                            </small>
                        </base-input>
                    </div>

                </div>

                <div class="form-row">
                    <div class="col">
                        <base-checkbox class="mb-3" v-model="consent" data-vv-as="consent" v-validate="'required:true'"
                                       name="consent" required>
                            I hereby state that the physical location of this device is in Belgium and take full
                            responsibility for any consequences of wrongfully setting the postal
                            code of this device.
                        </base-checkbox>
                        <div class="form-group has-danger">
                            <span class="error" style="width: 100%;">{{ getError('consent') }}</span>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col">
                            <base-checkbox class="mb-3" v-model="consent2" data-vv-as="consent2"
                                           v-validate="'required:true'"
                                           name="consent2" required>
                                I hereby vow to update the postal code if the physical location of the device changes.
                            </base-checkbox>
                            <div class="form-group has-danger">
                                <span class="error" style="width: 100%;">{{ getError('consent2') }}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </template>


        <template slot="footer">
            <base-button type="primary" native-type="submit" @click.prevent="validate"
                         :loading="saving"> Save changes
            </base-button>
            <base-button type="secondary" @click.native="$emit('update:show', false)">Close</base-button>
        </template>
    </modal>
</template>

<script>
import Modal from "../../components/Modal";

export default {
    name: "EmergencyCallingModal",
    components: {
        Modal,
    },
    props: {
        sipdevice: String,
        show: Boolean,
    },
    data() {
        return {
            postal_code: null,
            consent: false,
            consent2: false,
            saving: false,
        }
    },
    computed: {
        sipdevices() {
            return this.$store.getters['sipdevice/sipdevices'];
        },
        currentSipdevice() {
            return this.sipdevices.filter(sp => sp.name === this.sipdevice)[0]
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        validate() {
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    this.updateEmergencyCalling()
                }
            })
        },
        handleModalClose(value) {
            this.$emit('update:show', value);
        },
        updateEmergencyCalling() {
            this.saving = true;
            this.$axios
            this.$store.dispatch('sipdevice/saveEmergencyCalling', {
                sipdevice: this.currentSipdevice.id,
                postal_code: this.postal_code
            }).then(() => {
                if (this.$store.getters['sipdevice/needUpdate']) {
                    this.$store.dispatch('sipdevice/loadSIPDevices');
                }
                this.saving = false;
                this.$emit('update:show', false);
                this.$notify({
                    position: "top-right",
                    message: this.sipdevice + '\'s emergency settings saved!',
                    type: "success",
                    icon: "fal fa-save",
                    title: "Saved!"
                });
            }).catch(() => {
                this.saving = false;
                this.$notify({
                    position: "bottom-right",
                    message: this.sipdevice + '\'s emergency settings failed to save!',
                    type: "error",
                    icon: "fal fa-times",
                    title: "Error!"
                });
            });
        },
    },
    mounted() {
        this.postal_code = this.currentSipdevice.emergency_calling
    },
    watch: {
        // whenever sipdevice changes, this function will run
        sipdevice: function (newSipDevice, oldSipDevice) {
            if (this.sipdevice != null) {
                this.consent = false;
                this.consent2 = false;
                this.postal_code = this.currentSipdevice.emergency_calling
            }
        },
    }
}
</script>

<style scoped>

</style>
